import { render, staticRenderFns } from "./PreviewProyects.vue?vue&type=template&id=067c7ee4&scoped=true"
import script from "./PreviewProyects.vue?vue&type=script&lang=js"
export * from "./PreviewProyects.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/home.css?vue&type=style&index=0&id=067c7ee4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c7ee4",
  null
  
)

export default component.exports